const groupLinks = {
  details: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}`,

  overview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/overview`,

  preview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/preview`,

  sharing: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/sharing`,

  settings: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/settings`,

  contents: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/contents`,

  metadata: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/metadata`,

  activity: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/biomedical-imaging/${namespace}/${groupId}/activity`,
};

export default groupLinks;
